const forge = require("node-forge");

module.exports = {
  
  now: () => {
    return forge.util.bytesToHex( forge.random.getBytesSync(8) );
  },
  
}